// extracted by mini-css-extract-plugin
export default {"arrow":"ArrowButton-module--arrow--2yM-K","next":"ArrowButton-module--next--1RgyE","prev":"ArrowButton-module--prev--3z02J"};